export function newsPopup() {
  const popup = document.getElementById("acf-auto-popup");

  if (popup) {
    // Eindeutiger Name für das Cookie basierend auf dem Startdatum
    const popupId = popup.getAttribute("data-startdate") || "default";
    const cookieName = "popup_closed_" + popupId;

    const closeBtn = popup.querySelector(".close-popup-btn");

    // 1. Hilfsfunktion: Cookie auslesen
    function getCookie(name) {
      let matches = document.cookie.match(
        new RegExp(
          "(?:^|; )" +
            name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
            "=([^;]*)",
        ),
      );
      return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    // 2. Hilfsfunktion: Cookie setzen mit Ablaufzeit in Tagen
    function setCookie(name, value, days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Tage in Millisekunden
      const expires = "; expires=" + date.toUTCString();
      // path=/ sorgt dafür, dass das Cookie auf der gesamten Website gilt
      document.cookie =
        name +
        "=" +
        encodeURIComponent(value) +
        expires +
        "; path=/; SameSite=Lax";
    }

    // 3. Prüfen, ob das Cookie bereits existiert
    if (!getCookie(cookieName)) {
      // Wenn kein Cookie da ist, Popup anzeigen
      popup.style.display = "flex";
    }

    // Funktion beim Schließen: Popup verstecken und Cookie für 5 Tage setzen
    function closeAndSavePopup() {
      popup.style.display = "none";
      setCookie(cookieName, "true", 5); // <- Hier kannst du die "5" bei Bedarf anpassen
    }

    // 4. Schließen bei Klick auf das "X"
    closeBtn.addEventListener("click", closeAndSavePopup);

    // 5. Schließen bei Klick außerhalb der Popup-Box
    popup.addEventListener("click", function (e) {
      if (e.target === popup) {
        closeAndSavePopup();
      }
    });
  }
}
